var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaption = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#caption_svg__a)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M8.78 4.694H4.573m4.209 2.56H4.572m.353 3.507 1.337 1.108c.24.198.588.2.829.002l1.358-1.112a.65.65 0 0 1 .413-.147h1.214a1.93 1.93 0 0 0 1.942-1.92V3.256c0-1.06-.87-1.92-1.942-1.92H3.277a1.93 1.93 0 0 0-1.942 1.92v5.438c0 1.06.87 1.919 1.942 1.919H4.51c.152 0 .299.053.416.15"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "caption_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13.354v13.354H0z"
})))));
export default SvgCaption;